module.exports = __webpack_public_path__ + "static/media/educationimg.2c9035f6.webp";